import {BaseConfig} from "../../../../infrastructure/config/base-config";
import {AppTerms} from "../../../../core/app/app-terms";

export class SideBarModuleConfig extends BaseConfig {

  static injectables = [AppTerms];

  constructor(terms: AppTerms) {
    super('sideBarModule', null, terms);
  }
}
